import React, {useEffect, useState} from 'react';
import './NextThankYouSurvey.scss';
import {useNavigate, useParams} from "react-router-dom";
import SurveyHero from "../../../../components/Survey/SurveyHero/SurveyHero";
import {deletePreviousSurveyData, deleteSurveyData, updateSurveyPage} from "../../../../../redux/actions/survey";
import {useDispatch} from "react-redux";
import LeaveGoogleReviewCard from "../../../../components/LeaveGoogleReviewCard";


const NextThankYouSurvey = ({showGlobalSnackbar, survey, i18n, app}) => {

    const navigate = useNavigate();
    const {code} = useParams();
    const dispatch = useDispatch();


    const [patientName, setPatientName] = useState(null);

    useEffect(() => {
        if (survey?.previousSurveyData?.patient?.name || survey?.patient?.name) {
            setPatientName(survey?.previousSurveyData?.patient?.name ?? survey?.patient?.name);
        }
    }, [survey]);

    useEffect(() => {
        if (patientName) {
            dispatch(deleteSurveyData());
        }
    }, [patientName]);





    const [surveyData, setSurveyData] = useState(null);
    const [showGoogleReviewCard, setShowGoogleReviewCard] = useState(false);
    const [reviewLink, setReviewLink] = useState()

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(updateSurveyPage(5));
        // dispatch(deleteSurveyData());
        // dispatch(deletePreviousSurveyData());
    }, []);

    useEffect(() => {
        if(survey?.data){
            if(survey.settings?.clinic?.googleLink){
                console.log('survey.settings?.clinic?.googleLink',survey.settings?.clinic?.googleLink);
                setReviewLink(survey.settings?.clinic?.googleLink?.startsWith("http")
                    ? survey?.settings?.clinic?.googleLink
                    : `https://${survey?.settings?.clinic?.googleLink}`);
            }

            setSurveyData(survey?.data);
        }
    }, [survey]);

    useEffect(() => {
        if(surveyData){
            if(surveyData?.healthChanges?.find(item => item.name === "openEnded5")?.concernRate == 5 && survey.settings?.clinic?.googleLink){
                setShowGoogleReviewCard(true);
            }

            dispatch(deleteSurveyData());
            dispatch(deletePreviousSurveyData());
        }
    },[surveyData]);

    const nextPage = () => {
      //
    }

    return (
        <div className="FirstScreenSurvey">

            <SurveyHero
                step={survey?.settings?.thankSubtitle
                    ? survey.settings.thankSubtitle.trim().endsWith('!')
                        ? `${survey.settings.thankSubtitle.slice(0, -1)} ${patientName ?? ''}!`
                        : `${survey.settings.thankSubtitle} ${patientName ?? ''}`
                    : ''}
                headline={survey?.settings?.thankHeadline}
                // step={survey?.settings?.thankSubtitle}
                // headline={survey?.settings?.thankHeadline ? `${survey?.settings?.thankHeadline} ${patientName ?? ""}` : ''}
                text={survey?.settings?.thankText}
                videoLink={survey?.settings?.thankVideo}
                buttonText={""}
                clickedButton={() => nextPage()}
                app={app}
                surveyType={survey?.settings?.type}
                reviewCard={
                    showGoogleReviewCard ? <LeaveGoogleReviewCard showLink={true} reviewLink={reviewLink}/> : null
                }
            />


        </div>
    );
};

export default NextThankYouSurvey;
